import { Component, inject, model } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdvertisingService } from '../services/advertising.service';
import { AdvertisingFormComponent } from '../advertising-form/advertising-form.component';
import { AccessService } from '../../core/services/access.service';
import { AdvertisingInterface } from '../interfaces/advertising.interface';
import { Advertising } from '../models/advertising.model';

@Component({
  selector: 'app-advertising-edit',
  standalone: true,
  imports: [AdvertisingFormComponent],
  templateUrl: './advertising-edit.component.html',
  styleUrl: './advertising-edit.component.css',
})
export class AdvertisingEditComponent {
  private route = inject(ActivatedRoute);
  private service = inject(AdvertisingService);

  protected access = inject(AccessService).access;
  protected id!: string | null;

  value = model<Advertising>();
  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Editar la Pantalla');
    this.route.paramMap.subscribe((params) => {
      this.id = params.get('id');
      this.service.get(params.get('id')).subscribe((data) => {
        this.value.update((value) => {
          value = new Advertising(data.data as AdvertisingInterface);
          return value;
        });
      });
    });
  }
}
